import { Routes } from '@angular/router';
import { LoginNovoComponent } from './login-novo.component';

export const LoginRoutes: Routes = [
  {
    path: '',
    component: LoginNovoComponent
  },
  { path: '', loadChildren: '../paginas/paginas.module#PaginasModule' }
];
